import React from 'react';
import { Button, Col, FormGroup, Row } from 'react-bootstrap';
import { Box, Label } from 'fw/components';
import { Form, TextBox, IntBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'
import * as Notifications from 'fw/globals/Notifications'

class SimpleFormDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				textbox: "Peter"
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleValidate = (form) => {
		if (form.yourAge - form.yourAge10 !== 10)
			return "Ooops! Shouldn't that result in a 10 years difference? :-)"
	}

	handleSubmit = () => {
		Notifications.success("Form submittes succesfully!");
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="Simple Form">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onValidate={this.handleValidate}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Your Name</Label>
								<TextBox name="textbox" />
							</FormGroup>
						</Col>
						<Col md={2}>
							<FormGroup>
								<Label required>You Age?</Label>
								<IntBox name="yourAge" required />
							</FormGroup>
						</Col>
						<Col md={2}>
							<FormGroup>
								<Label required>Your Age 10 years ago?</Label>
								<IntBox name="yourAge10" required />
							</FormGroup>
						</Col>
						<col md={4}>
						</col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default SimpleFormDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Forms/SimpleFormDemo.js